import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import FeatureCard from "./components/FeatureCard";
import Select from "react-select";
import AreaChart from "../../../components/Graph/AreaChart";
import { useDispatch } from "react-redux";
import {
  getCharacterRevenue,
  getDashboardData,
  getRevenue,
} from "../../../store/dashboard/actions";
import AreaChartNew from "../../../components/Graph/AreaChartNew";
import { getAppearnace } from "../../../store/appearance/actions";
const Dashboard = () => {
  const dispatch = useDispatch();
  const [dashBoardData, setDashBoardData] = useState();
  const [revenue, setReveneue] = useState();
  const [characterRevenue, setCharacterReveneue] = useState();
  const [selectedFilters, setSelectedFilters] = useState({});
  const [appearanceData, setAppearanceData] = useState();
  const currentYear = new Date().getFullYear();
  const years = [];
  const newYears = [];
  const [filter, setFilter] = useState({
    filter: "weekly",
  });
  const [filterNew, setFilterNew] = useState({
    filter: "weekly",
  });
  for (let i = -10; i <= 0; i++) {
    years.push({ value: currentYear + i, label: (currentYear + i).toString() });
  }

  for (let i = -10; i <= 0; i++) {
    newYears.push({
      value: currentYear + i,
      label: (currentYear + i).toString(),
    });
  }
  // Set initial state to the current year
  const [selectedYear, setSelectedYear] = useState(
    years.find((year) => year.value === currentYear)
  );
  const [selectedNewYear, setSelectedNewYear] = useState(
    newYears.find((year) => year.value === currentYear)
  );
  // const fetchApearanceData = async () => {
  //   try {
  //     const callback = (err, res) => {
  //       if (err) {
  //         toast.err(err);
  //       } else {
  //         console.log(res, "resposne dta");
  //         setAppearanceData(res);
  //       }
  //     };
  //     // dispatch(getAppearnace({ callback }));
  //   } catch (error) {
  //     console.log(error, "error");
  //   }
  // };
  // useEffect(() => {
  //   fetchApearanceData();
  // }, []);
  // const fetchRevenue = () => {
  //   try {
  //     const callback = (err, res) => {
  //       if (err) {
  //         console.log(err, "err");
  //       } else {
  //         setReveneue(res);
  //       }
  //     };
  //     // dispatch(getRevenue({ data: filter, callback }));
  //   } catch (error) {}
  // };
  // useEffect(() => {
  //   fetchRevenue();
  // }, [filter]);
  // const fetchCharacterRevenue = () => {
  //   try {
  //     const callback = (err, res) => {
  //       if (err) {
  //         console.log(err, "err");
  //       } else {
  //         console.log(res, "response======<>");
  //         setCharacterReveneue(res);
  //       }
  //     };
  //     // dispatch(getCharacterRevenue({ data: filterNew, callback }));
  //   } catch (error) {}
  // };
  // useEffect(() => {
  //   fetchCharacterRevenue();
  // }, [filterNew]);
  const fetchData = () => {
    try {
      const callback = (err, res) => {
        if (err) {
          console.log(err, "err");
        } else {
          setDashBoardData(res);
        }
      };
      dispatch(getDashboardData({ callback }));
    } catch (error) {}
  };
  useEffect(() => {
    fetchData();
  }, []);
  const HandleYearGraph = (filterType) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      filter: filterType,
    }));
  };
  const HandleCharacterYearGraph = (filterType) => {
    setFilterNew((prevFilter) => ({
      ...prevFilter,
      filter: filterType,
    }));
  };
  const handleChange = (selectedOption) => {
    setSelectedYear(selectedOption);
    setFilter((prev) => ({
      ...prev,
      year: selectedOption.value.toString(),
    }));
  };
  const handleChangeCharacter = (selectedOption) => {
    setSelectedNewYear(selectedOption);
    setFilterNew((prev) => ({
      ...prev,
      year: selectedOption.value.toString(),
    }));
  };
  const handleSelectChange = (fieldName, value) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [fieldName]: value[0],
    }));
  };
  const handleFilter = () => {
    setFilterNew((prev) => ({
      ...prev,
      ...selectedFilters,
    }));
  };
  const clearFilter = () => {
    setSelectedFilters({});
    setFilterNew({ filter: "weekly" });
  };
  console.log(appearanceData, "appearanceData");
  return (
    <>
      <section className="position-relative">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <FeatureCard dashBoardData={dashBoardData?.data} />
            </Col>
            <Col className="my-2" lg="12"></Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Dashboard;
